export const darkTheme = {
  bg: "#0B0F1A",
  bgLight: "#0F1629",
  primary: "#00AEEF",
  hover: "#FF4F49",
  text_primary: "#F6F7FB",
  text_secondary: "#A9B0C0",
  card: "#0F172A",
  card_light: "#0C1222",
  button: "#00AEEF",
  white: "#FFFFFF",
  black: "#000000",
};

export const lightTheme = {
  bg: "#FFFFFF",
  bgLight: "#f0f0f0",
  primary: "#ec9b00",
  text_primary: "#111111",
  text_secondary: "#48494a",
  card: "#FFFFFF",
  button: "#5c5b5b",
};

// border: 0.1px solid #3f5efb;
// box-shadow: rgba(63,94,251, 0.32) 0px 4px 24px;
